import { CandidateCampaignResponse } from "../Classes/CandidateCampaignResponse";
import axios, { AxiosResponse } from "axios";
const url = "/api/messages";

export const axiosCandidateInterest = async (
  candidateCampaignResponse: CandidateCampaignResponse
): Promise<AxiosResponse | undefined> => {
  try {
    var result = await axios.post(url, candidateCampaignResponse);

    return result;
  } catch (error) {
    console.error("Error in axiosCandidateInterest", error);
    return undefined;
  }
};
